module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d4/sec07_pc_41dcac69427fb37dcfb7ad2efea4a314.jpg";